import * as React from 'react';
import { LabelConfig } from '../types';

export const InputLabel = (props: LabelConfig) => {
    return props.visible !== false ?
       <div className="control-label">
          {props.required ? <span className="asterisk-required">* </span> : null}
          {props.icon ? <span className={`default-icon ${props.icon}`} /> : null}
          {props.text}
          {props.children}
         </div> : null; 
};
